import { Injectable } from '@angular/core';
import { catchError, map, mergeMap, of, retryWhen, switchMap } from 'rxjs';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { retryStrategy } from '@personal-area/global/http/services';

import { VpsStats } from '../../models/bonus-stats';
import { PromoApiService } from '../../services/promo.api.service';
import * as promoActions from '../actions/promo';

@Injectable()
export class PromoEffects {

  constructor(
    private _actions$: Actions,
    private _promoService: PromoApiService,
  ) {
  }

  getPromos$ = createEffect(() =>
    this._actions$
      .pipe(
        ofType(promoActions.GetPromos),
        switchMap(() => this._promoService.getPromos()
          .pipe(
            retryWhen(retryStrategy()),
            map(list => promoActions.GetPromosSuccess(list)),
            catchError(error => of(promoActions.GetPromosFail(error)))
          ))
      )
  );

  getStats$ = createEffect(() =>
    this._actions$
      .pipe(
        ofType(promoActions.GetStats),
        mergeMap(data => {
          const initialStats = data.promo === 'vps' ? VpsStats : {};

          return this._promoService
            .getBonusStats(data.promo)
            .pipe(
              retryWhen(retryStrategy()),
              map(_stats => {
                const stats = Object.assign({ ...initialStats }, _stats || {});
                return promoActions.GetStatsSuccess({ ...stats, name: data.promo, promoIdLegacy: data.promoId });
              }),
              catchError(error => {
                if (error.status === 404) {
                  return of(promoActions.GetStatsSuccess({
                    ...initialStats,
                    name: data.promo,
                    promoIdLegacy: data.promoId
                  }));
                }
                return of(promoActions.GetStatsFail(error));
              })
            );
        }
        )
      )
  );
}

